import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import axios from 'axios';
import UnifyButton from '../../../../../components/Button';
import ModalFilter from './ModalFilter';
import { N400, Y400 } from '../../../../../components/Colors';
import config from '../../../../../config';
import { getQueryParam } from '../../helper/urlHelper';
import xlsDownloader from '../../helper/xlsDownloader';

const Filter = ({
  filter, setFilter, appliedFilter, handleApplyFilter,
}) => {
  const [show, setShow] = useState(false);

  const handleOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleApplyModal = () => {
    handleClose();
    handleApplyFilter();
  };

  const handleNamaKegiatanChange = (e) => {
    const newFilter = { ...filter };
    newFilter.nama_kegiatan = e.target.value;
    setFilter(newFilter);
  };

  const handleDownload = () => {
    const ending = getQueryParam(appliedFilter);
    axios
      .get(`${config.API_BASE_URL}api/kuliah_umum/download/${ending}`, {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        responseType: 'arraybuffer',
      })
      .then((response) => {
        xlsDownloader(response.data);
      });
  };

  return (
    <>
      <Container className="mt-4 mb-2">
        <Row style={{ alignItems: 'center' }}>
          <Col md={2}>
            <UnifyButton
              color={Y400}
              textColor={N400}
              onClick={handleOpen}
            >
              Tambah filter
            </UnifyButton>
          </Col>
          <Col md={2}>
            <UnifyButton color="#DCDCDC" textColor={N400} onClick={handleDownload}>Unduh</UnifyButton>
          </Col>
          <Col md={{ span: 4, offset: 4 }}>
            <InputGroup>
              <Form.Control
                type="text"
                name="nama_kegiatan"
                data-testid="nama_kegiatan"
                value={filter.nama_kegiatan}
                onChange={(e) => {
                  handleNamaKegiatanChange(e);
                }}
                placeholder="Cari nama kegiatan"
              />
              <InputGroup.Append>
                <InputGroup.Text id="basic-addon2" onClick={handleApplyFilter} data-testid="search">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                  </svg>
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Col>
        </Row>
      </Container>
      <ModalFilter
        filter={filter}
        setFilter={setFilter}
        show={show}
        handleClose={handleClose}
        handleApplyFilter={handleApplyModal}
      />
    </>
  );
};

Filter.propTypes = {
  appliedFilter: PropTypes.shape({
    jenis_kegiatan: '', nama_kegiatan: 0, tanggal: '', penyelenggara: '',
  }).isRequired,
  handleApplyFilter: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    jenis_kegiatan: '', nama_kegiatan: 0, tanggal: '', penyelenggara: '',
  }).isRequired,
};

export default Filter;
